import {
   allUsers,
   checkIDURL,
   checkSitepresenceUrl,
   confirmUrl,
   countAlarmsUrl,
   createSitepresence,
   deleteUserURL,
   emailCheck,
   endSitepresenceUrl,
   explicitHeader,
   inRange,
   isSBCGoLightAdmin,
   parking,
   passwordResetURL,
   postFeedback,
   regexURL,
   registerUrl,
   requestPasswordResetURL,
   reVerificationURL,
   routeByCode,
   stationByCode,
   stationURL,
   updateUserURL,
   user,
   userID,
   versionURL,
   webcamByCode
} from '@/utils/constants/constants'

import axios from 'axios'
import store from '@/store'

/**
 * Makes the login request. Tells Vuex to dispatch the request and to store a cookie, so that the user stays
 * logged in after a page refresh
 * @param {*} user Userinput (name and password) from the login form
 */
export function makeLoginRequest(user) {
   return new Promise((resolve, reject) => {
      store
         .dispatch('login', user)
         .then(() => {
            resolve()
         })
         .catch(err => {
            reject(err)
         })
   })
}

// Returns version of the Api
export async function getVersion() {
   const token = localStorage.getItem('access_token')
   try {
      const response = await axios.get(versionURL, {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
      return response.data
   } catch (error) {
      return error.message
   }
}

// Gets UserID
export async function getUserID() {
   const token = localStorage.getItem('access_token')
   try {
      const response = await axios.get(userID, {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
      return response.data
   } catch (error) {
      return error.message
   }
}

// Gets Name of User
export async function getUser(userID) {
   const token = localStorage.getItem('access_token')
   try {
      const response = await axios.get(user + '/' + userID, {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
      return response.data
   } catch (error) {
      return error.message
   }
}

// Get stations by url
export async function getStations() {
   const token = localStorage.getItem('access_token')
   try {
      const response = await axios.get(stationURL, {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
      return response.data
   } catch (error) {
      return error.message
   }
}

export async function getParking(code) {
   const token = localStorage.getItem('access_token')
   return await axios.get(parking + '/' + code + '/' + 'parking', {
      headers: {
         Authorization: 'Bearer ' + token
      }
   })
}

// Get stations by coordinates
export async function getStationsInRange(lat, long, radius) {
   const token = localStorage.getItem('access_token')
   try {
      const response = await axios.get(inRange, {
         params: {
            latitude: lat,
            longitude: long,
            radius: radius
         },
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
      return response.data
   } catch (error) {
      return error.message
   }

}

// Creates Sitepresence
export async function makeSitepresence(url) {
   const token = localStorage.getItem('access_token')
   try {
      return await axios.get(createSitepresence + url, {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
   } catch (error) {
      return error.message
   }
}

export async function checkSitepresence(url) {
   const token = localStorage.getItem('access_token')
   try {
      return await axios.get(checkSitepresenceUrl + url, {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
   } catch (error) {
      return error.message
   }
}

export async function countAlarms(url) {
   const token = localStorage.getItem('access_token')
   try {
      return await axios.get(countAlarmsUrl + url, {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
   } catch (error) {
      return error.message
   }
}

export async function endSitepresence(url) {
   const token = localStorage.getItem('access_token')
   try {
      return await axios.get(endSitepresenceUrl + url, {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
   } catch (error) {
      return error.message
   }
}

// Gets station by code
export async function getStation(code) {
   const token = localStorage.getItem('access_token')
   try {
      const response = await axios.get(stationByCode + '/' + code, {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
      return response.data
   } catch (error) {
      return error.message
   }
}

// Gets webcam by code
export async function getWebcam(code) {
   const token = localStorage.getItem('access_token')
   try {
      const response = await axios.get(webcamByCode + '/' + code + '/webcam', {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
      return response.data
   } catch (error) {
      return error.message
   }
}

// Gets route to Station by code
export async function getRoute(code) {
   const token = localStorage.getItem('access_token')
   try {
      const response = await axios.get(routeByCode + '/' + code + '/route', {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
      return response.data
   } catch (error) {
      return error.message
   }
}

// Creates Feedback
export async function makeFeedback(feedback) {
   const token = localStorage.getItem('access_token')
   try {
      const response = await axios.post(postFeedback, feedback, {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
      console.log(response)

      return response
   } catch (error) {
      return error.message
   }
}

// Tells vuex to logout the user and end the session at the backend
export function logout() {
   return new Promise((resolve, reject) => {
      store
         .dispatch('logout')
         .then(() => {
            resolve()
         })
         .catch(e => {
            reject(e)
         })
   })
}

// Sends a Register Request to the Backend
export async function register(credentials) {
   const token = localStorage.getItem('access_token')
   try {
      return await axios.post(registerUrl, credentials, {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
   } catch (error) {
      return error
   }
}

export async function requestPasswordReset(email) {
   const token = localStorage.getItem('access_token')
   return await axios.post(requestPasswordResetURL, email, explicitHeader)
}

export async function resetPassword(password, id) {
   const token = localStorage.getItem('access_token')
   return await axios.post(
      passwordResetURL,
      { password, id },
      {
         headers: {
            Authorization: 'Bearer ' + token
         }
      }
   )
}

export async function checkID(id) {
   const token = localStorage.getItem('access_token')
   return await axios.get(
      checkIDURL,
      { params: { id } },
      {
         headers: {
            Authorization: 'Bearer ' + token
         }
      }
   )
}

export async function checkEmail(email) {
   const token = localStorage.getItem('access_token')
   try {
      await axios.post(emailCheck, email, explicitHeader)
      return true
   } catch (err) {
      console.log(err.response)
      return false
   }
}

export async function verifyUser(id) {
   const token = localStorage.getItem('access_token')
   return new Promise(function(resolve, reject) {
      axios
         .post(confirmUrl, id, explicitHeader)
         .then(resp => {
            resolve(resp)
         })
         .catch(err => {
            reject(err)
         })
   })
}

export async function isGoLightAdmin() {
   const token = localStorage.getItem('access_token')
   try {
      const resp = await axios.get(isSBCGoLightAdmin, {
         headers: {
            Authorization: 'Bearer ' + token
         }
      })
      return resp.data
   } catch (err) {
      console.log(err)
      return false
   }
}

export async function getAllEmailRegexes() {
   const token = localStorage.getItem('access_token')
   return await axios.get(regexURL, {
      headers: {
         Authorization: 'Bearer ' + token
      }
   })
}

export async function addEmailRegex(regex) {
   const token = localStorage.getItem('access_token')
   return await axios.put(regexURL, regex, {
      headers: {
         Authorization: 'Bearer ' + token
      }
   })
}

export async function updateEmailRegex(regex) {
   const token = localStorage.getItem('access_token')
   return await axios.put(regexURL, regex, {
      headers: {
         Authorization: 'Bearer ' + token
      }
   })
}

export async function deleteEmailRegex(regex) {
   const token = localStorage.getItem('access_token')
   return await axios.delete(regexURL, {
      data: regex,
      headers: {
         Authorization: 'Bearer ' + token
      }
   })
}

export async function getAllUsers() {
   const token = localStorage.getItem('access_token')
   return await axios.get(allUsers, {
      headers: {
         Authorization: 'Bearer ' + token
      }
   })
}

export async function deleteUser(user) {
   const token = localStorage.getItem('access_token')
   return await axios.delete(
      deleteUserURL,
      { data: user },
      {
         headers: {
            Authorization: 'Bearer ' + token
         }
      }
   )
}

export async function updateUser(user) {
   const token = localStorage.getItem('access_token')
   return await axios.put(updateUserURL, user, {
      headers: {
         Authorization: 'Bearer ' + token
      }
   })
}

export async function sendReVerificationRequest(user) {
   const token = localStorage.getItem('access_token')
   return await axios.post(reVerificationURL, user, {
      headers: {
         Authorization: 'Bearer ' + token
      }
   })
}
